export default "__VITE_ASSET__CIAfNvur__"